module.exports = __webpack_public_path__ + "img/modal-settings.ef75ca53.svg";